<template lang="pug">
  .home-hero-content.container(:class="{'hide': hideComponent}")
    .row.top-row
      .xs-hide.sm-5.title-wrap
        .centered-wrap.sm-text-left
          .inner-title-wrap.v-center
            h1.title.f-secondary.color-mr-purple.sm-f-grande.lg-f-xxxgrande.max-at-tweak(v-html="title")
            .inner-cta-wrap
              a.mr-btn.sm-f-xxsmall.md-f-xxsmall.lg-f-xsmall.max-at-tweak(
                v-if="link.url"
                @click="trackMREvent(linkEventName);"
                :href="link.url"
                data-mr-ass="cta-button"
                tabindex="0"
                :class="secondaryLinkClasses"
              ) {{ link.text }}

              a.secondary-link.mr-btn.btn-block.btn-secondary.sm-f-xxsmall.md-f-xxsmall.lg-f-xsmall.max-at-tweak(
                v-if="hasToShowSecondaryLink"
                @click="trackMREvent(secondaryLink.eventName);"
                :href="secondaryLink.url"
                data-mr-ass="secondary-cta-button"
                tabindex="0"
              ) {{ secondaryLink.text }}

      .xs-12.sm-7.image-wrapper
        a(
          v-if="link.url"
          @click="trackMREvent(imageClickEventNAme);"
          :href="link.url"
          data-mr-ass="cta-button"
          tabindex="0"
        )
          .a-box-content
            ResponsiveImage.hero-img(:media-obj="image" xs-aspect-key="3x2" sm-aspect-key="4x5" md-aspect-key="10x9" lg-aspect-key="3x2")

    .row.xs-12.sm-hide.md-hide.lg-hide.xs-mt-15.xs-mb-15(:class="mobileRowClasses")
      .centered-wrap.xs-text-left
        .inner-title-wrap.v-center
          h1.title.f-secondary.color-mr-purple.xs-f-grande.max-at-tweak(v-html="title")
          .inner-cta-wrap
            a.mr-btn.xs-f-xxsmall.max-at-tweak(
              v-if="link.url"
              @click="trackMREvent(linkEventName);"
              :href="link.url"
              data-mr-ass="cta-button"
              tabindex="0"
              :class="secondaryLinkClasses"
            ) {{ link.text }}

            a.secondary-link.mr-btn.btn-block.btn-secondary.xs-f-xxsmall.max-at-tweak(
              v-if="hasToShowSecondaryLink"
              @click="trackMREvent(secondaryLink.eventName);"
              :href="secondaryLink.url"
              data-mr-ass="secondary-cta-button"
              tabindex="0"
            ) {{secondaryLink.text}}

</template>

<script>
  import ResponsiveImage from '@components/ResponsiveImage';
  import { mapState, mapActions } from 'vuex';

  export default {

    name: 'HomeHero',

    components: {
      ResponsiveImage,
    },

    inject: ['getObjProperty'],

    props: {
      title: {
        type: String,
        default: 'YOUR. BEST.<br />hair COLOR. EVER.',
      },
      link: {
        type: Object,
        default: () => ({
          text: null,
          url: null,
        }),
      },
      linkEventName: {
        type: String,
        default: '',
      },
      imageClickEventName: {
        type: String,
        default: '',
      },
      image: {
        type: Object,
        required: true,
      },
      videoConsult: {
        type: Object,
        default: () => ({
          text: 'Need color advice?',
          ctaText: 'Book a free video consult',
        }),
      },
      hidesForRV: {
        type: Boolean,
        default: false,
      },
      secondaryLink: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      isMounted: false
    }),

    computed: {
      ...mapState('customer', ['cdata']),

      ...mapState('colorAdvisor', ['advisorCompleted']),

      showReturnVisitorComponents() {
        return this.isMounted && !!this.cdata && !!this.cdata.cid && !this.advisorCompleted;
      },

      isCloseToColorbar() {
        return !!(this.getObjProperty(this.cdata, 'locationContext.closestColorbar'));
      },

      hideComponent() {
        return this.hidesForRV && (this.getObjProperty(this.cdata, 'visitorType') == 'Return Visitor');
      },

      hasToShowSecondaryLink() {
        return this.secondaryLink && this.secondaryLink.url && (this.secondaryLink.criterionForHidding !== 'always' && (this.secondaryLink.criterionForHidding == 'farFromHub' && !this.isCloseToColorbar));
      },

      secondaryLinkClasses() {
        return {
          'btn-block': this.hasToShowSecondaryLink
        };
      },

      mobileRowClasses() {
        return {
          'mobile-ctas-row': this.hasToShowSecondaryLink
        };
      }
    },

    mounted() {
      this.isAdvisorCompleted();
      this.isMounted = true;
    },

    methods: {
      ...mapActions('colorAdvisor', [
        'isAdvisorCompleted',
      ]),
    },
  };
</script>

<style lang="stylus">
  .home-hero-content
    max-height 35.86em
    overflow hidden
    max-width 92.875em
    margin 0 auto
    
    @media mq-mobile
      max-height 43.4em !important
    
    .top-row
      overflow hidden

    .title-wrap
      position relative
      height 35.86em
      @media mq-mobile
        height 25.5em
      
    .centered-wrap
      padding-top 50%
      
    .inner-title-wrap
      margin-left 8%

      h1
        margin-bottom 0.75em
      a
        padding 0.93em 1.14em

      .inner-cta-wrap
        max-width 21.86em

      .secondary-link
        margin-top 0.71em
      
    .image-wrapper
      height 35.86em
        
      .hero-img
        width 100%
        > img
          height 100%
          min-width 100%
          min-height 100%
          width unset

    .mobile-ctas-row
      min-height 17em

    @media mq-mobile
      .top-row
        max-height 25.5em
        
      .inner-title-wrap
        margin-bottom 14%
        margin-left 4%
        min-width 68%

        .title
          width 100%
          margin-left 0px !important
        
        a
          padding 0.93em 1.14em
          
      .image-wrapper
        height 17.15em
        
        .hero-img
          > img
            height unset !important
            width unset !important
            min-width 100%
    
      .centered-wrap
        margin-bottom 2.14em
        
    @media mq-tablet
      .home-hero-content
        max-height 22.86em !important
        height 22.86em
      .inner-title-wrap
        margin-left 4%
        a
          padding 0.93em 1.36em
</style>